import React from "react";
import { Card } from "@/components/ui/card";
import { Vault } from "lucide-react";
import { DocumentManager } from "@/components/DocumentManager";

export default function Coffre() {
  return (
    <div className="space-y-5 max-w-xl">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <Vault className="h-6 w-6 text-primary" /> Coffre-fort documentaire
        </h1>
        <p className="text-muted-foreground text-sm">Carte Vitale, attestation de droits, justificatifs — stockés en privé.</p>
      </div>
      <Card className="p-5 rounded-md shadow-none">
        <DocumentManager mode="self" />
      </Card>
    </div>
  );
}
